'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002491 from "./presto.types$$anon$91.js";
import * as $j_presto$002etypes$0024$002dAllow$002dPayload$0024 from "./presto.types$-Allow-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$90(outer) {
  this.c9Z = null;
  this.c9R = null;
  this.c9S = false;
  this.ca0 = null;
  this.ca1 = false;
  this.ca4 = null;
  this.c9X = null;
  this.c9Y = false;
  this.c9T = null;
  this.c9U = false;
  this.c9V = null;
  this.c9W = false;
  this.ca2 = false;
  this.ca3 = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ca4 = "AllowPayload";
}
export { $c_Lpresto_types$Rule$$anon$90 as $c_Lpresto_types$Rule$$anon$90 };
$p = $c_Lpresto_types$Rule$$anon$90.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$90;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$90() {
}
export { $h_Lpresto_types$Rule$$anon$90 as $h_Lpresto_types$Rule$$anon$90 };
$h_Lpresto_types$Rule$$anon$90.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c9Z;
});
$p.L = (function() {
  if ((!this.c9S)) {
    this.c9R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9S = true;
  }
  return this.c9R;
});
$p.O = (function() {
  if ((!this.ca1)) {
    this.ca0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ca1 = true;
  }
  return this.ca0;
});
$p.E = (function() {
  return this.ca4;
});
$p.t = (function() {
  if ((!this.c9Y)) {
    this.c9X = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.c9Y = true;
  }
  return this.c9X;
});
$p.M = (function() {
  if ((!this.c9U)) {
    this.c9T = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SM(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.c9U = true;
  }
  return this.c9T;
});
$p.Q = (function() {
  if ((!this.c9W)) {
    this.c9V = new $j_presto$002etypes$0024$0024anon$002491.$c_Lpresto_types$$anon$91();
    this.c9W = true;
  }
  return this.c9V;
});
$p.w = (function() {
  if ((!this.ca3)) {
    this.ca2 = false;
    this.ca3 = true;
  }
  return this.ca2;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee90) => ((p) => \u03b4scrutinee90.cGf(p)))($j_presto$002etypes$0024$002dAllow$002dPayload$0024.$m_Lpresto_types$AllowPayload$())));
});
var $d_Lpresto_types$Rule$$anon$90 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$90, "presto.types$Rule$$anon$90", ({
  a1b: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$90 as $d_Lpresto_types$Rule$$anon$90 };
//# sourceMappingURL=presto.types$-Rule$$anon$90.js.map
